import { isCityAdminUser } from "./cityPortalRoles"

export const ADMIN_USER_TYPES = ["super_admin", "admin"]

export const isAdminUser = user =>
  ADMIN_USER_TYPES.includes(user?.type)

/** Platform admin or city admin — both use AdminLayout. */
export const isAdminPortalUser = user =>
  isAdminUser(user) || isCityAdminUser(user)

export const getAdminHomePath = () => "/admin/dashboard"
